import { hsaQuestionnaireStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

/**
 * Read-only flow view of the team's active HSA questionnaire flow. Beta:
 * the handler 404s for non-Redo-employee users.
 */
export const getHsaQuestionnaireFlowSteps = {
  name: "getHsaQuestionnaireFlowSteps" as const,
  input: z.null(),
  output: z.object({
    /** hsa_questionnaire_settings.enabled — gates session minting only. */
    questionnaireEnabled: z.boolean(),
    /** Null when no active (non-empty) flow is configured for the team. */
    flow: z
      .object({
        flowId: z.string(),
        name: z.string(),
        /** "creator • ISO timestamp", mirroring the checkout tree label. */
        label: z.string(),
        steps: hsaQuestionnaireStepArraySchema,
      })
      .nullable(),
  }),
};
